import {Component, OnInit} from '@angular/core';
import {SearchRequest} from '../../../../shared/models/request/search-request';
import {LocalDataSource} from 'ng2-smart-table';
import {TaskTypeCategory} from '../../../../shared/models/response/task-type-category';
import {NbDialogService} from '@nebular/theme';
import {CommonService} from '../../../../shared/services/common.service';
import {RestResult} from '../../../../shared/models/response/rest-result';
import {ComponentPermission} from '../../../../component.permission';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {TaskStatusService} from '../../../../shared/services/task-status.service';
import {TaskStatusCreateComponent} from './create/task-status-create.component';
import {TaskStatusUpdateComponent} from './update/task-status-update.component';
import {Constant} from '../../../../shared/common/constant';

@Component({
  selector: 'ngx-task-status',
  templateUrl: './task-status.component.html',
  styleUrls: ['./task-status.component.scss'],
})
export class TaskStatusComponent implements OnInit {
  ComponentPermission = ComponentPermission;
  searchRequest: SearchRequest = new SearchRequest();
  source: LocalDataSource = new LocalDataSource();
  change: any;
  pageSize = Constant.PAGE_SIZE;

  settings = {
    mode: 'external',
    actions: {
      add: ComponentPermission.isAccess(ComponentPermission.TASK_STATUS_CREATE),
      edit: ComponentPermission.isAccess(ComponentPermission.TASK_STATUS_EDIT),
      delete: ComponentPermission.isAccess(ComponentPermission.TASK_STATUS_DELETE),
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    pager: {
      display: true,
      perPage: this.pageSize,
    },
    columns: {
      taskStatusId: {
        title: 'ID',
        type: 'number',
      },
      name: {
        title: 'Name',
        type: 'string',
      },
      description: {
        title: 'Description',
        type: 'string',
      },
    },
  };

  constructor(private dialogService: NbDialogService,
              private commonService: CommonService,
              private taskStatusService: TaskStatusService) {

  }

  ngOnInit() {
    this.source.onChanged().subscribe((change) => {
      this.change = change;
      if (change.action === 'refresh') {
        this.loadRequest(1);
        // this.pageChange(change.paging.page);
      }
      if (change.action === 'page') {
        // this.source.load(new Array());
        this.loadRequest(change.paging.page);
      }
      if (change.action === 'sort') {
        this.source.load(new Array());
        this.loadRequest(1);
      }
      if (change.action === 'filter') {
        this.source.load(new Array());
        this.loadRequest(1);
      }
    });
  }

  search() {
    this.loadRequest(1);
  }

  loadRequest(pageIndex) {
    this.prepareRequest();
    this.taskStatusService.search(this.searchRequest).subscribe((result: RestResult) => {
      this.source.load(result.data);
    });
  }

  prepareRequest() {
    // init conditions
    if (!this.searchRequest.conditions) {
      this.searchRequest.conditions = new Array();
    }
    this.searchRequest.conditions = new Array();
    if (this.change.filter && this.change.filter.filters.length > 0) {
      this.change.filter.filters.forEach(filter => {
        if (filter.search && filter.search.trim() !== '') {
          if (filter.field.includes('Id') && isFinite(filter.search)) {
            this.searchRequest.conditions.push(
              {
                left: filter.field,
                middle: '=',
                right: Number(filter.search),
              },
            );
          } else {
            this.searchRequest.conditions.push(
              {
                left: filter.field,
                middle: 'like',
                right: filter.search,
              },
            );
          }
        }
      });
    }

    // init orders
    this.searchRequest.orders = new Array();
    if (this.change.sort && this.change.sort.length > 0) {
      this.change.sort.forEach(sort => {
        this.searchRequest.orders.push(
          {
            left: sort.field,
            right: sort.direction,
          },
        );
      });
    } else {
      this.searchRequest.orders.push(
        {
          left: 'taskStatusId',
          right: 'desc',

        },
      );
    }
  }

  deleteRecord(event: any) {
    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        content: 'Do you really want to delete?',
      },
    })
    .onClose.subscribe(res => {
      if (res === ConfirmDialogComponent.confirmOk) {
        this.taskStatusService.remove(event.data.taskStatusId).subscribe(
          result => {
            this.commonService.info('Delete successfully');
            this.loadRequest(this.change.paging.page);
          }, error => {
            this.commonService.warning(error.message);
          });
      }
    });
  }


  addRecord(event: any) {
    this.dialogService.open(TaskStatusCreateComponent)
    .onClose.subscribe(result => {
      if (result) {
        this.loadRequest(this.change.paging.page);
      }
    });
  }

  editRecord(event: any) {
    this.dialogService.open(TaskStatusUpdateComponent, {
      context: {
        data: event.data,
      },
    })
    .onClose.subscribe(result => {
      if (result) {
        this.loadRequest(this.change.paging.page);
      }
    });
  }

}
